module.exports = __webpack_public_path__ + "static/img/6.3de8ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/eng/6.png
// module id = BRvJ
// module chunks = 0